import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface MarketingConsentState {
  answered: boolean;
  markAnswered: () => void;
  reset: () => void;
}

export const useMarketingConsentStore = create<MarketingConsentState>()(
  devtools(
    (set) => ({
      answered: false,
      markAnswered: () => set(() => ({ answered: true }), false, 'markAnswered'),
      reset: () => set(() => ({ answered: false }), false, 'reset'),
    }),
    {
      name: 'Marketing Consent Store',
      enabled: import.meta.env.DEV,
    },
  ),
);
